import { ApiRoute, HttpMethod } from '../../../common/api/routes';
import { LocationId } from '../../../location/Location';
import { Instagram } from '../../constants';
import { BasicInstagramDetailsWithLinkedPage, UpdateInstagramConfigDto } from './types';

export const InstagramEndpoints = {
    getAvailableInstagramAccountsForLocation: new ApiRoute<
        BasicInstagramDetailsWithLinkedPage[],
        { locationId: LocationId },
        void,
        void
    >(HttpMethod.Get, path =>
        path
            .literal('integration')
            .literal(Instagram.name)
            .literal('location')
            .param('locationId')
            .literal('options'),
    ),
    getConnectedInstagramAccountForLocation: new ApiRoute<
        BasicInstagramDetailsWithLinkedPage,
        { locationId: LocationId },
        void,
        void
    >(HttpMethod.Get, path =>
        path
            .literal('integration')
            .literal(Instagram.name)
            .literal('location')
            .param('locationId'),
    ),
    updateConfiguration: new ApiRoute<void, { locationId: LocationId }, UpdateInstagramConfigDto, void>(
        HttpMethod.Post,
        path =>
            path
                .literal('integration')
                .literal(Instagram.name)
                .literal('location')
                .param('locationId'),
    ),
};
